module.exports = __webpack_public_path__ + "static/img/icon-logo-sh1.e14b2503.png";